<template>
  <v-row class="pb-12">
    <v-col cols="12">
      <provider-title style="display: inline-block" title="Apariencia"></provider-title>

      <v-btn
          v-if="!isMobile"
          :disabled="!hasChanged"
          :loading="savingSettings"
          @click="save"
          small
          absolute
          top
          right
          color="primary"
      >
        <v-icon size="16" class="mr-1">save</v-icon>
        Guardar
      </v-btn>

      <v-btn
          v-if="isMobile"
          :disabled="!hasChanged"
          :loading="savingSettings"
          @click="save"
          fixed
          fab
          bottom
          right
          color="primary"
      >
        <v-icon>save</v-icon>
      </v-btn>

      <provider-sub-title class="mt-4" text="Tema Visual:"/>
    </v-col>

    <v-col cols="12">
      <v-alert :value="!!description" dark color="primary" border="left" dense>{{description}}.</v-alert>
    </v-col>

    <v-col cols="12">
      <background-picker
        :value="bgComponent"
        @change="setSelectedBG"
      />
    </v-col>

    <v-col cols="12">
      <v-divider/>
    </v-col>

    <v-col cols="12">
      <p class="caption pb-0">Configuraciones del fondo</p>
      <v-switch
          persistent-hint
          hint="Si tu dispositivo se vuelve lento con el tema seleccionado, desactiva la animación del fondo."
          :disabled="!animated"
          v-model="selectedAnimateBG"
          label="Activar animación" />
    </v-col>

    <v-col cols="12">
      <v-divider/>
    </v-col>

    <v-col cols="12">
      <provider-sub-title text="Colores de fondo:" class="mb-3" />
      <color-array-picker
          show-presets
          allow-add
          :disabled="!maxColors"
          :min-colors="minColors"
          :max-colors="maxColors"
          :value="selectedBGColors"
          @change="onColorsChange"
      />
    </v-col>

  </v-row>
</template>

<script>

import ProviderTitle from "@/components/providers/panel/ProviderTitle.vue";
import ProviderSubTitle from "@/components/providers/panel/ProviderSubTitle.vue";
import BackgroundPicker from "@/components/common/backgrounds/BackgroundPicker.vue";

import {ApiUtils} from "@/utils/ApiUtils";
import UIMixin from "@/mixins/UIMixin";
import ProviderSettingsMixin from "@/mixins/ProviderSettingsMixin";
import ColorArrayPicker from "@/components/common/backgrounds/ColorArrayPicker.vue";

export default {
  mixins: [UIMixin, ProviderSettingsMixin],
  components: {
    ColorArrayPicker,
    BackgroundPicker,
    ProviderTitle,
    ProviderSubTitle,
  },
  data() {
    return {
      saved: false,

      description: '',
      animated: false,
      minColors: 2,
      maxColors: 5,

      selectedBGComponent: null,
      selectedBGColors: [],
      selectedAnimateBG: false,
    }
  },
  props: { },
  mounted() {
    const vm = this
    const { ui_settings } = vm.currentProviderSettings
    if(ui_settings && ui_settings.animate_bg_if_available !== undefined){
      vm.selectedAnimateBG = ui_settings.animate_bg_if_available
    }
  },
  beforeDestroy(){
    const vm = this
    vm.setSavedSettingsBackToStorage()
  },
  methods: {

    onColorsChange(colors){
      const vm = this
      vm.selectedBGColors = [...colors];
      vm.setBGColors([...colors])
    },

    setSavedSettingsBackToStorage(){
      const vm = this
      const { ui_settings } = vm.currentProviderSettings
      if(!ui_settings){
        return
      }

      const {
        bg_component,
        bg_colors,
        animate_bg_if_available,
      } = ui_settings

      vm.setBGComponent(bg_component)
      vm.setBGColors(bg_colors)
      vm.setAnimateBGIfAvailable(animate_bg_if_available)
    },

    async save(){
      const vm = this

      const settings = vm.currentProviderSettings
      let newSettings = {
        bg_component: vm.selectedBGComponent,
        bg_colors: vm.selectedBGColors,
        animate_bg_if_available: vm.selectedAnimateBG
      }

      if(settings && settings.ui_settings){
        newSettings = {...settings.ui_settings, ...newSettings}
      }

      const response = await vm.saveSettings({ui_settings: newSettings})

      if(response) {
        await ApiUtils.fetchMe()
        vm.saved = true
        vm.toast('La configuración se ha guardado')
      }else{
        vm.toast('Ha ocurrido un error guardando la configuración', 'error')
      }

    },

    setSelectedBG(bg){
      const vm = this
      const {
        component,
        description,
        animated,
        minColors,
        maxColors,
        defaultColors,
      } = bg

      vm.selectedBGComponent = component
      vm.description = description
      vm.animated = animated
      vm.minColors = minColors
      vm.maxColors = maxColors

      const colorsToSet = vm.bgColors.length ? [...vm.bgColors] : [...defaultColors]
      vm.selectedBGColors = colorsToSet
      vm.setBGColors(colorsToSet)

      vm.setBGComponent(component)
      vm.limitColors(bg.maxColors)

      const { ui_settings } = vm.currentProviderSettings
      if(!bg.animated && ui_settings){
        vm.selectedAnimateBG = ui_settings.animate_bg_if_available
      }
    },

    limitColors(maxColors){
      const vm = this
      if(!maxColors || maxColors >= vm.selectedBGColors.length) return

      const itemsToRemove = vm.selectedBGColors.length - maxColors
      vm.selectedBGColors.splice((maxColors - 1), itemsToRemove)
    }
  },
  computed: {
    hasChanged(){
      const vm = this
      const settings = vm.currentProviderSettings
      const {
        bg_colors,
        bg_component,
        animate_bg_if_available,
      } = settings.ui_settings

      const colorsAreEqual = JSON.stringify(vm.bgColors) === JSON.stringify(bg_colors)
      const componentIsEqual = vm.selectedBGComponent === bg_component
      const animateBGIsEqual = vm.selectedAnimateBG === animate_bg_if_available

      return !colorsAreEqual || !componentIsEqual || !animateBGIsEqual
    }
  },
  watch: {
    selectedBGComponent(val){
      const vm = this
      if(val !== vm.bgComponent) {
        vm.changed = true
      }
    },
    selectedAnimateBG(val){
      const vm = this
      vm.setAnimateBGIfAvailable(val)
    }
  }
}
</script>

<style scoped>
img {
  width: 100%;
  height: auto;
}

.cover {
  z-index: 50;
  max-height: 450px;
}
.cover-div {
  position: relative;
}
.cover-image {
  position: absolute;
  top: 5px;
  right: 5px;
}
.avatar-div {
  position: absolute;
  z-index: 100;
  top: 50%;
  left: 5%;
  transform: translateY(-50%);
}
.logo {
  width: 100px;
  height: 100px;
  border: 3px solid #fff;
  border-radius: 100%;
}
.avatar-image {
  position: absolute;
  top: 45px;
  right: 5px;
}
.hidden {
  display: none;
}
.titulo {
  position: absolute;
  top: 50%;
  left: 100px;
  margin-top: -19px;
  font-size: 23px;
  font-weight: 400;
  min-width: 300px;
}
</style>
